<template>
  <div class="nav-header-mobile isFixed">
    <div class="header">
      <div class="content">
        <div>
          <router-link to="/">
            <img class="logo-img" src="../assets/new-logo.png" />
          </router-link>
        </div>
      </div>
      <div>
        <div class="hanber-img" @click="modal22 = true">
          <img src="../assets/mobile/汉堡按钮.svg" />
        </div>
        <Modal v-model="modal22" footer-hide class="modal-mobile" width="95">
          <Row class="mobile-row1" @click.native="link1">
            <Col :span="5">
              <img src="../assets/mobile/CaaS.png" />
            </Col>
            <Col :span="19">
              <p class="mobile-title">{{ $t("nav.Open") }}</p>
              <p class="mobile-des">{{ $t("nav.OpenSca") }}</p>
            </Col>
          </Row>
          <Row class="mobile-row1" @click.native="link2">
            <Col :span="5">
              <img src="../assets/mobile/RedteaGo.png" />
            </Col>
            <Col :span="19">
              <p class="mobile-title">{{ $t("nav.RedteaGO") }}</p>
              <p class="mobile-des">{{ $t("nav.GlobalData") }}</p>
            </Col>
          </Row>
          <Row class="mobile-row1" @click.native="link3">
            <Col :span="5">
              <img src="../assets/mobile/redteaready.png" />
            </Col>
            <Col :span="19">
              <p class="mobile-title">RedteaReady</p>
              <p class="mobile-des">{{ $t("nav.Turnkey") }}</p>
            </Col>
          </Row>
          <Divider />
          <Row class="mobile-row2">
            <Col :span="12" class="mobile-link" @click.native="link1"
              >{{ $t("nav.CaaS") }}
            </Col>
            <Col :span="12" class="mobile-link" @click.native="link2"
              >{{ $t("nav.RedteaGO") }}
            </Col>
          </Row>
          <Row class="mobile-row2">
            <Col :span="12" class="mobile-link" @click.native="link3"
              >{{ $t("nav.RedteaReady") }}
            </Col>
            <Col :span="12" class="mobile-link" @click.native="link9"
              >{{ $t("nav.eSIM") }}
            </Col>
          </Row>
          <Row class="mobile-row2">
            <Col :span="12" class="mobile-link" @click.native="eSimPlusLink"
              >{{ $t("nav.eSimPlus") }}
            </Col>
            <Col :span="12" class="mobile-link" @click.native="link4"
              >{{ $t("nav.Resources") }}
            </Col>
          </Row>
          <Row class="mobile-row2">
            <Col :span="12" class="mobile-link" @click.native="link5"
              >{{ $t("nav.AboutUs") }}
            </Col>
            <Col :span="12" class="mobile-link" @click.native="link6"
              >{{ $t("nav.ContactUs") }}
            </Col>
          </Row>
          <Divider />
          <Row>
            <div class="mobile-enquiry" @click="enquiryClick">
              {{ $t("enquiry") }}
            </div>
          </Row>
          <Row>
            <div class="mobile-lang" @click="handleSwitch">
              {{ flag ? "中 文" : "ENGLISH" }}
            </div>
          </Row>
        </Modal>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "nav-header-mobile",
  data() {
    return {
      theme1: "light",
      modal22: false,
      searchBarFixed: true,
      flag: true,
    };
  },
  mounted() {
    this.flag = this.$i18n.locale === "en";
  },
  methods: {
    handleSwitch() {
      window.open("https://www.redteamobile.com/", "_blank");
    },
    enquiryClick() {
      this.modal22 = false;
      this.$router.push({
        path: "/enquiry-mobile",
      });
    },
    link1() {
      this.modal22 = false;
      this.$router.push({
        path: "/CaaS",
      });
    },
    link2() {
      this.modal22 = false;
      this.$router.push({
        path: "/RedteaGo",
      });
    },
    link3() {
      this.modal22 = false;
      this.$router.push({
        path: "/RedteaReady",
      });
    },
    link4() {
      this.modal22 = false;
      this.$router.push({
        path: "/Resources",
      });
    },
    link5() {
      this.modal22 = false;
      this.$router.push({
        path: "/about",
      });
    },
    link6() {
      this.modal22 = false;
      this.$router.push({
        path: "/Contact",
      });
    },
    link9() {
      this.modal22 = false;
      this.$router.push({
        path: "/RedteaSIM",
      });
    },
    eSimPlusLink() {
      this.modal22 = false;
      this.$router.push({
        path: "/esim-plus",
      });
    },
  },
};
</script>
<style lang="less">
.isFixed {
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 1000;
}

.ivu-input {
  border: none !important;
  border-bottom: 1px solid rgba(140, 140, 140, 1) !important;
  border-radius: 0px !important;
  font-family: "Poppins-Light";
  font-size: 0.14rem;
}

.ivu-input:focus {
  box-shadow: none !important;
}

.nav-header-mobile {
  .header {
    background: rgba(255, 255, 255, 1);
    padding: 0.2rem;
    height: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: none;
    align-items: center;
    margin: 0 auto;
    align-items: center;

    .logo-img {
      width: 1.2rem;
    }

    .hanber-img {
      margin-top: 0.1rem;
    }

    .hanber-img img {
      width: 0.24rem;
    }
  }
}

.modal-mobile {
  .ivu-modal {
    top: 0 !important;
  }

  img {
    width: 0.42rem;
  }

  .mobile-title {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-Medium";
    font-size: 0.14rem;
    line-height: 0.21rem;
  }

  .mobile-des {
    color: rgba(32, 49, 82, 1);
    font-size: 0.12rem;
    font-family: "Poppins-ExtraLight";
    line-height: 0.18rem;
  }

  .mobile-link {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-Regular";
    font-size: 0.14rem;
    line-height: 0.21rem;
    padding-left: 5%;
  }

  .mobile-enquiry {
    background-color: rgba(207, 42, 42, 1);
    border-radius: 4px;
    width: 3.15rem;
    height: 0.34rem;
    line-height: 0.34rem;
    color: rgba(255, 255, 255, 1);
    font-family: "Poppins-Bold";
    font-size: 0.12rem;
    text-align: center;
    margin: 0.2rem 0;
  }

  .mobile-lang {
    background-color: rgba(32, 49, 82, 1);
    border-radius: 4px;
    width: 3.15rem;
    height: 0.34rem;
    line-height: 0.34rem;
    color: rgba(255, 255, 255, 1);
    font-family: "Poppins-Bold";
    font-size: 0.12rem;
    text-align: center;
    margin-bottom: 0.3rem;
  }

  .mobile-row1 {
    margin: 0.15rem auto;
  }

  .mobile-row2 {
    margin: 0.2rem auto;
  }
}

.mobile-iphone {
  .ivu-modal-body {
    padding-bottom: 0px !important;
  }

  .mobile-box {
    display: flex;
    margin-top: 26px;
    position: relative;
  }

  .mobile-img {
    position: absolute;
    width: 152px;
    height: auto;
    bottom: 0;
    left: -16px;
  }

  .down-img {
    width: 106px;
    height: auto;
    margin-top: 92px;
    margin-bottom: 49px;
    margin-left: 49vw;
  }

  .modal-title {
    font-family: "Poppins-Bold";
    font-size: 24px;
    color: rgba(32, 49, 82, 1);
    text-align: center;
    margin: 40px auto 20px auto;
    padding: 0 10%;
  }

  .modal-line {
    width: 90%;
    height: 1px;
    border-bottom: 1px solid rgba(33, 50, 83, 0.69);
    margin: auto;
    margin-bottom: 36px;
  }

  .iphone-title-2 {
    font-family: "Poppins-SemiBold";
    font-size: 16px;
    color: rgba(32, 49, 82, 1);
    margin-bottom: 10px;
    padding: 0 5%;
  }

  .iphone-lists {
    font-family: "Poppins-Regular";
    font-size: 12px;
    color: rgba(32, 49, 82, 0.79);
    margin-bottom: 0.1rem;
    position: relative;
    padding: 0 5% 0 8%;
  }

  .iphone-lists::before {
    position: absolute;
    left: 5%;
    top: 0px;
    content: "-";
  }

  .ch-only {
    font-family: "Poppins-Regular";
    font-size: 12px;
    color: rgba(32, 49, 82, 0.79);
    padding: 0 5% 0 5%;
    margin-top: 20px;
  }

  .iphone-bottom {
    font-family: "Poppins-Regular";
    font-size: 0.2rem;
    margin-top: 1.2rem;
  }

  .more {
    margin-top: 0.4rem;
    font-family: "Poppins-Regular";
    font-size: 12px;
    color: rgba(255, 255, 255, 1);
    background: rgba(32, 49, 82, 0.99);
    border-radius: 10px;
    padding: 6px 0;
    width: 120px;
    text-align: center;
    cursor: pointer;
    margin-left: 5%;
  }
}
</style>